/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/schedulerobjects/scheduler_reporting.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SchedulerobjectsJobReport
 */
export interface SchedulerobjectsJobReport {
    /**
     * 
     * @type {string}
     * @memberof SchedulerobjectsJobReport
     */
    report?: string;
}

export function SchedulerobjectsJobReportFromJSON(json: any): SchedulerobjectsJobReport {
    return SchedulerobjectsJobReportFromJSONTyped(json, false);
}

export function SchedulerobjectsJobReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulerobjectsJobReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report': !exists(json, 'report') ? undefined : json['report'],
    };
}

export function SchedulerobjectsJobReportToJSON(value?: SchedulerobjectsJobReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report': value.report,
    };
}

